import { HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Typography, Spacing } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

interface LoadingOfferProps {}

export const LoadingOffer: React.FC<LoadingOfferProps> = () => {
  return (
    <HStack justifyContent="space-between" alignItems="center">
      <HStack alignItems="center" space={Spacing['inline.xxxs']}>
        <Skeleton
          width="54px"
          height="48px"
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
        <VStack space={Spacing['inline.quarck']} w="70px">
          <Skeleton
            w="full"
            h={Typography['fontsize.md']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w="full"
            h={Typography['fontsize.md']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </VStack>
      </HStack>
      <VStack space={Spacing['inline.quarck']} w="120px">
        <Skeleton
          w="full"
          h={Typography['fontsize.md']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
        <Skeleton
          w="full"
          h={Typography['fontsize.md']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
        <Skeleton
          w="full"
          h={Typography['fontsize.md']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </VStack>
    </HStack>
  );
};
